/**
 * External dependencies
 */
import { omit } from 'lodash';
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { START_MAPPING_SALES_TYPES } from 'state/action-types';

import { createReducer } from 'state/utils';

export const salesTypeId = createReducer(null, {
    [START_MAPPING_SALES_TYPES]: (state, { payload }) => payload.salesTypeId,
});

export default combineReducers({
    salesTypeId,
});
